import React, { useState } from 'react';
import { Switch, useLocation } from 'react-router-dom';
import { useSpring } from 'react-spring';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { Container } from './styles';

export const Desktop: React.FC = ({ children }) => {
  const location = useLocation();
  const [retract, setRetract] = useState(false);

  const props = useSpring({
    gridTemplateColumns: retract
      ? '5rem calc(100% - 5rem - 2.5rem)'
      : '12.8rem calc(100% - 12.8rem - 2.5rem)',
    config: {
      duration: 300,
    },
  });

  return (
    <Container isRetract={retract} style={{ ...props }}>
      <Sidebar handleRetract={() => setRetract(!retract)} isRetract={retract} />
      <Header />
      <section>
        <Switch location={location}>{children}</Switch>
      </section>
    </Container>
  );
};
